import { Column } from '@juristat/common/types'
import { createContext } from 'react'

type UpdateAction = (payload: Column[]) => void

export const SelectedColumnsItemsContext = createContext<Column[] | undefined>(undefined)
export const SelectedColumnsUpdateContext = createContext<UpdateAction | undefined>(undefined)
